﻿export function setupUIOverrides() {
    // no-op, all overrides are moved to corelib
}